import React from 'react';
import { Input, Grid, Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import TableTransportationList from './table/tableTransportationList';
import { HeaderTabelTransportation } from '../constant/headerTable';
import ButtonAction from '../../../../components/common/ButtonGroupSupplier';
import HeaderTitle from '../../../../components/common/headerTitle';
import Pagination from '../../../../components/common/pagination';
const TransportationList = props => (
  <div>
    <Grid columns="equal" style={{ marginTop: '30px' }}>
      <Grid.Row stretched>
        <Grid.Column>
          <Segment>
            <HeaderTitle title={props.title} />
            <Grid>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Input
                    icon="search"
                    placeholder="search"
                    name="searchInput"
                    value={props.searchInput}
                    onChange={props.handleChange}
                  />
                </Grid.Column>
                <Grid.Column width={12}>
                  <ButtonAction
                    buttonNew={props.buttonNew}
                    butttonExport={props.butttonExport}
                    buttonUploadData={props.buttonUploadData}
                    buttonDownloadTemplate={props.buttonDownloadTemplate}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <TableTransportationList
              data={props.data}
              headerTable={HeaderTabelTransportation}
              pageChange={props.pageChange}
              listData={props.listData}
              pagedData={props.pagedData}
              buttonDelete={props.buttonDelete}
              buttonEdit={props.buttonEdit}
            />
            <Pagination
              pagedData={props.pagedData}
              numbersTo={props.numbersTo}
              numbersFrom={props.numbersFrom}
              data={props.data}
              pageChange={props.pageChange}
              activePage={props.activePage}
            />
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);

TransportationList.propTypes = {
  listData: PropTypes.array,
  pagedData: PropTypes.array,
  title: PropTypes.string,
  pageChange: PropTypes.func,
  activePage: PropTypes.number,
  searchInput: PropTypes.string,
  handleChange: PropTypes.func,
  data: PropTypes.array,
  buttonNew: PropTypes.func,
  butttonExport: PropTypes.func,
  buttonUploadData: PropTypes.func,
  buttonDownloadTemplate: PropTypes.func,
  buttonDelete: PropTypes.func,
  buttonEdit: PropTypes.func,
  numbersFrom: PropTypes.number,
  numbersTo: PropTypes.number,
};
export default TransportationList;
